<template>
  <div class="event-thumbnail no-m card-container-outline" :class="thumbnailStyle" @click="openLink(eventInfo.link)">
    <p class=""><strong>{{ getFullDate(eventInfo)}}</strong></p>
    <p class="mb-1 italic">{{ eventInfo.eventName }}</p>
    <p class="italic small-text">{{ eventInfo.location }}</p>
    <div :class="eventInfo.type == 'market' ? 'event-type' : 'event-type yellow'">
      <p class="uppercase small-text">{{eventInfo.type}}</p></div>
  </div>
</template>
<script>
export default {
  name: 'EventThumbnail',
  props: ['eventInfo', 'index', 'type'],
  methods: {
    getFullDate(eventInfo) {
      if (eventInfo.endDate !== "") {
        return this.formatEventData(eventInfo.date) + " - " + this.formatEventData(eventInfo.endDate);
      } else {
        return this.formatEventData(eventInfo.date)
      }
    },
    formatEventData(dateString) {
      if (!dateString) return '';
      const [year, month, day] = dateString.split('-');
      const date = new Date(year, month - 1, day);
      const options = { month: 'long', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    openLink(link) {
      if (link !== '') {
        window.open(link);
      }
    }
  },
  computed: {
    thumbnailStyle() {
      var classes = this.eventInfo.link === '' ? '' : 'cursor';
      if (this.type === 'alternate-outline') {
        classes += [this.index % 2 === 0 ? 'bg-teal blue' : 'bg-cream blue'];
      } else {
        classes += [this.index % 2 === 0 ? 'bg-cream blue border-blue' : 'bg-cream blue border-blue']
      }
      return classes;
    }
  }
}
</script>
<style lang="scss">
@import "../assets/styles/variables";

.event-thumbnail {
  position: relative;
  border-radius: 20px;
}

.event-type {
  position: absolute;
  top: 1em;
  right: 1em;
  background-color: $blue;
  color: $teal;
  border-radius: 20px;
  border: 1px solid $blue-hover;
  padding: 5px 20px;

  p {
    margin: 0;
    padding: 0;
    text-align: center;
    font-weight: 600;
  }

  &.yellow {
    background-color: $yellow;
    color: $blue;
  }

}

.card-container-outline.border-blue {
  border: 1px solid $blue;
}

@media only screen and (max-width: 1023px) {
}

@media only screen and (max-width: 747px) {

}

</style>